// extracted by mini-css-extract-plugin
module.exports = {"selectLabel":"styles_selectLabel__254mm"};